  <h5 class="heading f-heading">Subscribe</h5>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <input #inp formControlName="username" type="text" class="form-control" placeholder="Name" (change)="onBlur(inp.value)"
             [class.is-invalid]="form.get('username')?.invalid && form.get('username')?.touched" />
      <span *ngIf="form.controls['username'].errors && form.controls['username'].touched" class="error">
        <span *ngIf="form.controls['username'].errors['required']"></span>
        <span *ngIf="form.controls['username'].errors['pattern']"></span>
        <span *ngIf="form.controls['username'].errors['minlength']"></span>
        <span *ngIf="form.controls['username'].errors['maxlength']"></span>
      </span>
    </div>
    <div class="mb-3">
      <input #email formControlName="email" type="email" class="form-control" placeholder="Email"
             [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched" />
      <span *ngIf="form.controls['email'].invalid && form.controls['email'].touched" class="error">
        <span *ngIf="form.controls['email'].errors['email']"></span>
        <span *ngIf="form.controls['email'].errors['required']"></span>
      </span>
    </div>
      <button class="btn btn-subscribe w-100 height32" type="submit"> Subscribe</button>
  </form>
<!-- <app-loader *ngIf="loader"></app-loader> -->

